import { AnalyzeTab } from '@/features/analyze/components/AnalyzeTab';
import { SearchField } from '@/components/Form';
import { SearchHelpIconModal } from '@/features/analyze/components/SearchHelpIconModal';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFilterConditionAtom } from '../atoms/filterCondition.atom';

export const AnalyzeHeader = () => {
  const { t } = useTranslation();
  const [filterCondition, setFilterCondition] = useFilterConditionAtom();
  const [queryInput, setQueryInput] = useState(filterCondition.query ?? '');
  const placeholder = t('analyze.search.freewordPlaceholder');

  useEffect(() => {
    setQueryInput(filterCondition.query ?? '');
  }, [filterCondition.query]);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <SearchField
          value={queryInput}
          onValueChange={setQueryInput}
          onSearch={(submittedQuery) => {
            setFilterCondition((prev) => ({
              ...prev,
              query: submittedQuery,
            }));
          }}
          placeholder={placeholder}
          leftIcon={<SearchHelpIconModal />}
        />
      </div>

      <AnalyzeTab />
    </div>
  );
};
